import { render, staticRenderFns } from "./permitTree2.vue?vue&type=template&id=2af8854e"
import script from "./permitTree2.vue?vue&type=script&lang=js"
export * from "./permitTree2.vue?vue&type=script&lang=js"
import style0 from "./permitTree2.vue?vue&type=style&index=0&id=2af8854e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports